module.exports = __webpack_public_path__ + "img/05-BABO.f9b74818.png";